// GET v2/distributions for the New Season pages (new_season_data slice).
const { useEffect, useCallback } = require('react');
const { useDispatch, useSelector } = require('react-redux');
const { load_new_season_distributions } = require('@actions/newSeasonActions');

// Loads once per mount of the caller (pass load = false to only read).
const useV2Distributions = (load = true) => {
  const dispatch = useDispatch();
  const distributions = useSelector(
    (state) => state.new_season_data?.distributions,
  );
  const status = useSelector(
    (state) => state.new_season_data?.distributions_status,
  );
  const reload = useCallback(
    () => dispatch(load_new_season_distributions()),
    [dispatch],
  );
  useEffect(() => {
    if (load) {
      reload();
    }
  }, [load, reload]);
  return { distributions, status, reload };
};

module.exports = { useV2Distributions };
